function replaceTextInNode(node, excludeCheck = false) {
    // Skip nodes that are inside the excluded div containing "Result_right" in the class
    if (excludeCheck && node.closest) {
        let closestDiv = node.closest('div');
        if (closestDiv && closestDiv.className.includes('Result_right')) {
            return;
        }
    }

    if (node.nodeType === Node.TEXT_NODE) {
        node.textContent = node.textContent
            .replace(/Mainland China/g, 'Sorting Facility')
            .replace(/, CHN/g, '')   // Removes ", CHN"
            .replace(/China/g, '')
            .replace(/CHN/g, '');    // Removes standalone "CHN"
    } else if (node.nodeType === Node.ELEMENT_NODE) {
        Array.from(node.childNodes).forEach(child => replaceTextInNode(child, excludeCheck));
    }
}

function replaceTextOnPage() {
    // Run initial text replacement without exclusion check
    replaceTextInNode(document.body, false);

    // Observe changes in the document body
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            mutation.addedNodes.forEach(node => replaceTextInNode(node, true));
        });
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

    // Set an interval to continuously check and replace text, with exclusion check
    const intervalId = setInterval(() => {
        replaceTextInNode(document.body, true);
    }, 500); // Adjust the interval time to 500 ms (0.5 seconds)

    // Clear the interval after 30 seconds
    setTimeout(() => {
        clearInterval(intervalId);
    }, 30000); // 30000 ms = 30 seconds
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', replaceTextOnPage);
} else {
    replaceTextOnPage();
}